import { CircularProgress, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import RightArrow from '../../../../animation/jobs/Right arrow.svg';
import SaveTickIcon from '../../../../animation/jobs/save_tickicon.svg';
import TickIcon from "../../../../animation/jobs/tick icon - full time.svg";
import DashboardRightFeedInnerComp from "../../../../components/commons/DashboardRightFeedInnerComp";
import ApplyPopup from "../../components/JobDetail/ApplyPopup";
import { ServiceApi } from "../../Service/ServiceApi";
import jobUtils from "../../utils/jobUtils";
import SavePopup from "../JobDetail/SavePopup";

import "./JobView.css";

function throttle(func, limit) {
  let inThrottle;
  return function () {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

function JobView() {

  const [job, setJob] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [open, setOpen] = useState(false); // <-- popup open state
  const containerRef = useRef(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const history = useHistory()
  const [tailorLoading, setTailorLoading] = useState(false);
  const [fitLoading, setFitLoading] = useState(false);
  const [fitModalOpen, setFitModalOpen] = useState(false);
  const [fitVerdict, setFitVerdict] = useState("");
  const [fitReasoning, setFitReasoning] = useState("");
  const [fitRecommendations, setFitRecommendations] = useState([]);
  const [fitImprovementPath, setFitImprovementPath] = useState("");
  const [fitEncouragingNote, setFitEncouragingNote] = useState("");


  const [resumePreviewUrl, setResumePreviewUrl] = useState(null);
  const [showResumePreview, setShowResumePreview] = useState(false);

  const token = localStorage.getItem("token");
  
  const { id } = useParams();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const profileId = userData?.profile_id;
  var isApplied = !!job?.isApplied;
  

const newsContent = [
    {
      thumbnail: "/Image/DashImage/news3.jpeg",
      href: "https://techcrunch.com/2025/07/31/chatgpt-everything-to-know-about-the-ai-chatbot/",
      content: "newsFeed.news1",
      channel: "newsFeed.TechCrunch",
    },
    {
      thumbnail: "/Image/DashImage/news3.jpeg",
      href: "https://techcrunch.com/2025/07/30/gen-ai-apps-doubled-their-revenue-grew-to-1-7b-downloads-in-first-half-of-2025/",
      content: "newsFeed.news2",
      channel: "newsFeed.TechCrunch",
    },
    {
      thumbnail: "/Image/DashImage/news3.jpeg",
      href: "https://techcrunch.com/2025/05/28/deepseek-everything-you-need-to-know-about-the-ai-chatbot-app/",
      content: "newsFeed.news3",
      channel: "newsFeed.TechCrunch",
    },
  ];
  

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
    }, 3000);
  };

   const handleCloseToast = () => {
   setShowToast(false);
 setToastMessage("");
 };

  useEffect(() => {
    const fetchJobView = async () => {
      try {
        const response = await ServiceApi.JobViewApi(token, id);
        setJob(response || null);
        setScroll();
      } catch (error) {
        console.error("Error fetching job view:", error);
      }
    };
    fetchJobView();
  }, [id]);

   

  function cleanJobDescription(text) {
    return text
      .replace(/[\n\r]+/g, " ")
      .replace(/[-•*]\s*/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }


   const handleEasyApply = () => {
    if (isApplied) {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 1000);
    } else {
      setOpen(true);
    }
  }

  const handleCloseApplyPopup = () => {
    setOpen(false);
  };

 const handleSave = async () => {
  try {
    if (!job?.isSaved) {
      // Save API
      const response = await ServiceApi.SavedApi(token, profileId, job.id, "saved");
      if (response.data?.id) {
        setJob((prev) => ({
          ...prev,
          isSaved: true,
          userjobInfo: response.data.id,
        }));
        setShowSavePopup(true);
      }
    } else {
      // Unsave API
      const response = await ServiceApi.DiscardApi(token, job.userjobInfo);
      if (response.status) {
        setJob((prev) => ({
          ...prev,
          isSaved: false,
          userjobInfo: null,
        }));
        showToastMessage("Job unsaved successfully");
      }
    }
    } catch (error) {
      console.error("Save error:", error);
    }
  };

   const handleTailorResume = async () => {
    try {
      setTailorLoading(true);
      const previewUrl = await ServiceApi.TailorResume(token, job.id);
      setResumePreviewUrl(previewUrl);
      setShowResumePreview(true); // Show modal
    } catch (err) {
      console.error("TailorResume Error:", err);
      showToastMessage("Failed to tailor resume. Please try again.");
    } finally {
      setTailorLoading(false);
    }
  };

  const handleFitForThisJob = async () => {
    try {
      setFitLoading(true);
      const res = await ServiceApi.FitForThisJob(token, job.id);

      const data = res?.data || null;

      const verdictText =
        data?.Verdict?.text || res?.verdict || res?.message || "";

      const reasoningText =
        data?.Reasoning?.text || data?.Reasoning || "";

      const recommendationsText =
        data?.Recommendations?.text || data?.Recommendations || "";

      const improvementPathText =
        data?.Improvement_path?.text || data?.Improvement_path || "";

      const encouragingNoteText =
        data?.encouraging_note?.text || data?.encouraging_note || "";

      setFitVerdict(String(verdictText || "").trim());
      setFitReasoning(String(reasoningText || "").trim());
      const recLines = String(recommendationsText || "")
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);

      setFitRecommendations(recLines);
      setFitImprovementPath(String(improvementPathText || "").trim());
      setFitEncouragingNote(String(encouragingNoteText || "").trim());

      setFitModalOpen(true);
    } catch (err) {
      console.error("FitForThisJob Error:", err);
      showToastMessage("Failed to analyze job fit. Please try again.");
    } finally {
      setFitLoading(false);
    }
  };

  const handleConfirmSave = () => {
    setShowSavePopup(false);
  };

  const setScroll = () => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => {
      if (container.scrollTop > 90) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    container.addEventListener("scroll", handleScroll);
    // cleanup
    return () => container.removeEventListener("scroll", handleScroll);
  };

  if (!job)
    return (
      <div className="loaderWrapper">
        <CircularProgress sx={{ color: "#f33070" }} />
      </div>
    );

  return (
    <div className="jobContainer" ref={containerRef}>
      <div className={`scrolledHeader ${isScrolled ? "show" : ""}`}>
        <div className="scrollHeaderInnerDiv">
          <div className="companyinfo">
            {jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) ? (
              <img
                src={
                  jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) ||
                  "/Image/fallback-company.png"
                }
                alt={`${job?.CompanyData?.company_name ?? "Company"} logo`}
                className="companyDetailLogo-small"
                onError={(e) => {
                  e.currentTarget.src = "/Image/fallback-company.png";
                }}
              />
            ) : (
              <div className="companyDetailLogo-Small">
                {job?.CompanyData.company_name?.charAt(0)?.toUpperCase()}
              </div>
            )}
            <div className="companyMeta-small">
              <h4 className="companyName-small">
                {job?.CompanyData.company_name}
              </h4>
              <p className="jobLocation-small">
                {job?.CompanyData.company_address}
              </p>
            </div>

            <div className="button-class">
              {job?.isApplied ? (
                <span className="appliedText">
                  <span className="appliedIconWrapper">
                    <img src={TickIcon} alt="Applied" />
                  </span>
                  <span>Applied {jobUtils.timeAgo(job?.isApplied?.applied_at)}</span>
                </span>
              ) : (
                <>
                  <button
                    className="easyApplyButton"
                    onClick={handleEasyApply}
                  >
                    Apply
                  </button>
                  <button
                    className={`saveButton ${job?.isSaved ? "saved" : ""}`}
                    onClick={handleSave}
                  >
                    {job?.isSaved ? "Saved" : "Save"}
                  </button>
                </>
              )}
            </div>
        
          </div>
        </div>
      </div>

      <div className="jobContent">
        <div className="section-box jobInfo">
          <div className="companyLogoContainer">
            {job?.CompanyData.company_logo ? (
              <img
                src={
                  jobUtils.decodeIfProxy(job?.CompanyData?.company_logo) ||
                  "/Image/fallback-company.png"
                }
                alt={`${job?.CompanyData?.company_name ?? "Company"} logo`}
                className="companyDetailLogo"
                onError={(e) =>
                  (e.currentTarget.src = "/Image/fallback-company.png")
                }
              />
            ) : (
              <div className="companyDetailLogoFallback">
                {job?.CompanyData.company_name?.charAt(0)?.toUpperCase()}
              </div>
            )}
            <div className="companyRow">
              <h4 className="companyName">{job?.CompanyData.company_name}</h4>
            </div>
          </div>

          <div className="jobInfoMain">
            <h1 className="jobTitle">{job?.title}</h1>
            <div className="locationInfo">
              <span>{job?.CompanyData.company_address}</span> •{" "}
              <span>{jobUtils.timeAgo(job?.timestamp)}</span>
            </div>

            <div className="badges">
              {job?.remote && job?.remote !== "NA" && (
                <button className="remoteBadge">
                 <img src={SaveTickIcon} width={20} height={16} />
                  {job?.remote && job.remote !== "NA" && (
                    job.remote === "onsite"
                      ? "On-Site"
                      : job.remote === "remote"
                        ? "Remote"
                        : null
                  )}
                </button>
              )}
              {job?.type && job?.type !== "NA" && (
                <button className="fullTimeBadge">
                  <img src={SaveTickIcon} width={20} height={16} />
                  {job.type === "fulltime" ? " Full-Time" : " Part-Time"}
                </button>
              )}
  
            </div>

            {job?.isApplied ? (
              <span className="appliedText">
                <span className="appliedIconWrapper">
                  <img src={TickIcon} alt="Applied" />
                </span>
               <span>
                    Applied {jobUtils.timeAgo(job?.isApplied?.applied_at)}
                  </span>
                  <span className="SeeApplicationjobview" onClick={() => history.push({ pathname: '/savejob/progress', state: { activeTab: 'progress' } })}>
                    See Application <img src={RightArrow} alt="Right arrow" />
                  </span>
              </span>
            ) : (
              <>
                <button className="easyApplyButton" onClick={handleEasyApply}>
                  Apply
                </button>
                <button
                  className={`saveButton ${job?.isSaved ? "saved" : ""}`}
                  onClick={handleSave}
                >
                  {job?.isSaved ? "Saved" : "Save"}
                </button>
              </>
            )}
          </div>
        </div>

        <div className="section-box profileFitSection">
          <div className="profileFitTitle">
            How your profile and resume fit this job
          </div>

          <div className="profileFitText">
            AI-crafted career insights just for you.
          </div>

          <div className="carouselSection">
            <button
              className="carouselItem"
              onClick={handleTailorResume}
              disabled={tailorLoading}
            >
              {tailorLoading ? "Tailoring..." : "Tailor my resume to this job"}
            </button>

            <button
              className="carouselItem"
              onClick={handleFitForThisJob}
              disabled={fitLoading}
            >
              {fitLoading ? "Analyzing..." : "Am I a good fit for this job?"}
            </button>

            <Link to="/courses" className="carouselItem">
              View Training Content
            </Link>

            <a
              href="https://calendly.com/nxnearby/30min"
              className="carouselItem"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Mock Interview
            </a>
          </div>
        </div>

        <div className="section-box jobDescription">
          <h3 className="sectionTitle">About the job</h3>
          {job?.description && (
            <Grid sx={{ mt: 2 }} className="descriptionTitle">
              <div>
                <b>Description</b>
              </div>
              <div className="descriptionText">
                {cleanJobDescription(job.description)}
              </div>
            </Grid>
          )}
        </div>
        <div style={{ height: 20 }} aria-hidden="true" />
      </div>

      {showSavePopup && <SavePopup onClose={handleConfirmSave} />}

      {showToast && (
        <div className="toastCard"><span>{toastMessage}</span>
          <span className="closeIcon" onClick={handleCloseToast}>&times;</span>
        </div>
      )}

      <div className="sidebars">
        
      <DashboardRightFeedInnerComp content={newsContent} />
      </div>

      {/* ApplyPopup wired in */}
      {open ? <ApplyPopup
        job={job}
        open={open}
        onClose={handleCloseApplyPopup} 
      /> : ''}
      {fitModalOpen && (
        <div
          className="fitModalOverlay"
          role="dialog"
          aria-modal="true"
          aria-label="Fit Analysis Result"
        >
          <div className="fitModalCard">
            <button
              className="fitCloseButton"
              aria-label="Close fit analysis"
              onClick={() => setFitModalOpen(false)}
            >
              ×
            </button>

            <div className="fitModalHeader">
              <h3 className="fitModalTitle">Fit Analysis</h3>
              <div
                className={`fitVerdictBadge ${
                  fitVerdict
                    ? fitVerdict.toLowerCase().includes("fit")
                      ? "good"
                      : fitVerdict.toLowerCase().includes("average")
                      ? "average"
                      : "bad"
                    : ""
                }`}
                aria-live="polite"
              >
                <span style={{ fontSize: 14 }}>{fitVerdict || "Analysis"}</span>
              </div>
            </div>

            <div className="fitModalGrid">
              <div className="fitColumn fitColumnLeft">
                <section className="fitCard" aria-labelledby="reasoning-title">
                  <h4 id="reasoning-title" className="fitCardTitle">
                    Reasoning
                  </h4>
                  <div className="fitCardContent">
                    {fitReasoning ? (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitReasoning}
                      </p>
                    ) : (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No reasoning available.
                      </p>
                    )}
                  </div>
                </section>

                <section
                  className="fitCard"
                  aria-labelledby="improvement-path-title"
                >
                  <h4 id="improvement-path-title" className="fitCardTitle">
                    Improvement Path
                  </h4>
                  <div className="fitCardContent">
                    {fitImprovementPath ? (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitImprovementPath}
                      </p>
                    ) : (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No improvement path available.
                      </p>
                    )}
                  </div>
                </section>

                <section
                  className="fitCard"
                  aria-labelledby="summary-title"
                >
                  <h4 id="summary-title" className="fitCardTitle">
                    Summary &amp; Encouragement
                  </h4>
                  <div className="fitCardContent">
                    {fitEncouragingNote ? (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, whiteSpace: "pre-wrap" }}
                      >
                        {fitEncouragingNote}
                      </p>
                    ) : (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No note available.
                      </p>
                    )}
                  </div>
                </section>
              </div>

              <div className="fitColumn fitColumnRight">
                <section
                  className="fitCard recommendationsCard"
                  aria-labelledby="recommendation-title"
                >
                  <h4 id="recommendation-title" className="fitCardTitle">
                    Recommendations
                  </h4>
                  <div className="fitCardContent">
                    {fitRecommendations && fitRecommendations.length > 0 ? (
                      <ul className="fitRecommendationList">
                        {fitRecommendations.map((line, idx) => {
                          const rawLine = String(line || "").trim();
                          return (
                            <li key={idx} className="fitRecommendationItem">
                              <span className="fitRecommendationText">
                                {rawLine}
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <p
                        className="fitReasoningText"
                        style={{ margin: 0, opacity: 0.7 }}
                      >
                        No recommendations available.
                      </p>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}

      {showResumePreview && (
        <div
          className="resumeOverlay"
          role="dialog"
          aria-modal="true"
          aria-label="Tailored resume preview"
        >
          <div className="resumeModal">
            <button
              className="closeButton"
              aria-label="Close preview"
              onClick={() => {
                if (resumePreviewUrl) window.URL.revokeObjectURL(resumePreviewUrl);
                setShowResumePreview(false);
                setResumePreviewUrl(null);
              }}
            >
              ✕
            </button>

            <div className="resumeHeader">
              <div>
                <h3 className="resumeTitle">Tailored Resume Preview</h3>
                <p className="resumeSubtitle">
                  Make sure everything looks perfect before you download.
                </p>
              </div>
            </div>

            <div className="resumeBody">
              {resumePreviewUrl ? (
                <div className="resumeFrameWrapper">
                  <iframe
                    src={resumePreviewUrl}
                    title="Tailored Resume Preview"
                    className="resumeIframe"
                    onLoad={(e) => {
                      e.currentTarget.classList.add('loaded');
                    }}
                  />
                </div>
              ) : (
                <div className="loadingState">
                  <div className="spinner"></div>
                  <p>Generating your tailored resume…</p>
                </div>
              )}
            </div>

            <div className="resumeFooter">
              <button
                className="secondaryButton"
                onClick={() => {
                  if (resumePreviewUrl) window.URL.revokeObjectURL(resumePreviewUrl);
                  setShowResumePreview(false);
                  setResumePreviewUrl(null);
                }}
              >
                Close
              </button>
              <button
                className="primaryButton"
                disabled={!resumePreviewUrl}
                onClick={() => {
                  if (!resumePreviewUrl) return;
                  const link = document.createElement("a");
                  link.href = resumePreviewUrl;
                  link.download = "tailored_resume.pdf";
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                }}
              >
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default JobView;
